import _ from 'underscore'

import summarise from './filter/summarise'
import stringify from './filter/stringify'
import parse from './filter/parse'

const types = []

const filterDefinitions = require.context('./filter/type', false, /\.js$/)

filterDefinitions.keys().forEach((filename) => {

    var definition = filterDefinitions(filename).default

    definition.key = filename.replace('.js', '').replace('./', '')

    types.push(definition)

})

var typesAssoc = {}

_.each(types, function(type) {

    typesAssoc[type.key] = type

})

export default {

    stringify: function(value) {

        return stringify.run(value)


    },
    
    parse: function(value) {

        return parse.run(value)


    },

    summarise: async function(value, $route) {

        return await summarise.run(value, $route)


    },

    cache: function(name, value) {

        return summarise.cache(name, value)

    },

    types: types,

    type: typesAssoc

}